<template>
  <v-btn-toggle
    v-model="option"
    dense
    background-color="accent"
    class="tab-container"
    color="white"
  >
    <v-btn class="delivery-tab" :color="`${tab == 0 ? 'primary' : color_disabled}`" @click="changeOption('free')" small>
      En tienda
    </v-btn>
    <div class="deliverOption-divider"></div>
    <v-btn class="delivery-tab" :color="`${tab == 1 ? 'primary' : color_disabled}`" @click="changeOption('cdmx')" small>
      A domicilio
    </v-btn>
  </v-btn-toggle>
</template>

<script>

export default {
  name: 'DeliveryOption',
  data:() => ({
    tab: 'free',
    option: 'free',
    color_disabled: 'accent'
  }),
  methods: {
    changeOption(val) {
      this.tab = val == 'free' ? 0 : 1
      this.$store.dispatch('setDeliveryTypeGlobal', val)
      this.option = val
      localStorage.setItem('option_delivery_mobile', this.option)
      this.color_disabled = 'gray'
    }
  },
  mounted() {
    let option_localstorage = localStorage.getItem('option_delivery_mobile')
    if (option_localstorage) {
      this.tab = option_localstorage == 'free' ? 0 : 1
      this.option = option_localstorage
      this.$store.dispatch('setDeliveryTypeGlobal', option_localstorage)
    }
  }
}
</script>

<style scoped>
  >>>.v-btn-toggle > >>>.v-btn.v-btn {
    border-style:none !important;
    opacity: 1 !important;
  }
  >>>.v-btn:not(.v-btn--round).v-size--small {
    height: 25px;
    color: white;
  }
  .deliverOption-divider {
    width: 2px;
    background-color: #FFF;
  }
  .delivery-tab {
    opacity: 1 !important;
  }
</style>
